import React from "react";
import classes from './../Svg1/Svg1.module.css';

const Svg2 = () => {
    return (
        <>
        <svg className={classes['svg']} preserveAspectRatio="xMidYMid meet" data-bbox="39.28 31 121.44 138" viewBox="39.28 31 121.44 138" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="presentation" aria-hidden="true">
            <g>
                <path d="M137.536 43.227v18.685h-13.248V43.144h-17.664v18.768H93.376V43.144H75.712v18.768H62.464V43.227C49.542 44.08 39.28 54.836 39.28 67.971v76.202C39.28 157.861 50.419 169 64.107 169h71.786c13.688 0 24.827-11.139 24.827-24.827V67.971c0-13.135-10.262-23.891-23.184-24.744zm16.56 100.946c0 10.035-8.168 18.203-18.203 18.203H64.107c-10.035 0-18.203-8.168-18.203-18.203V83.992h108.192v60.181z" fill="#e65439" data-color="1"></path>
                <path fill="#F283AD" d="M75.712 31v17.664H62.464V31h13.248z" data-color="2"></path>
                <path fill="#F283AD" d="M106.624 31v17.664H93.376V31h13.248z" data-color="2"></path>
                <path fill="#F283AD" d="M137.536 31v17.664h-13.248V31h13.248z" data-color="2"></path>
                <path fill="#53C1BE" d="M95.778 136.82l-15.473-15.471 4.062-4.058 11.023 11.025 20.07-24.081 4.408 3.674-24.09 28.911z" data-color="3"></path>
            </g>
        </svg>
        </>
    )
};

export default Svg2;